import { useAppConfig } from '#/config/AppConfigContext';
import { RouteModule } from '#/horizon/components/RouteModule';
import { useI18n } from '#/i18n/hooks/useI18n';
import { I18nLocale } from '#/i18n/types/I18nLocale';
import type { LayoutHandleProps } from '#/layouts/Layout/LayoutHandleProps';
import { ClientOnlyLazySearchInternshipRefinements } from '#/modules/search/internships/components/Refinements/ClientOnlyLazySearchInternshipRefinements';
import { searchInternshipsRoutePathByLocale } from '#/modules/search/internships/routing/searchInternships.route-paths';
import type { searchInternshipsRouteReference } from '#/modules/search/routing/search.routes';
import type { HorizonAppRouteLoaderArgs } from '#/routing/classes/types/AppRouteLoaderArgs';
import type { HorizonAppRouteComponentProps } from '#/routing/types/HorizonAppRouteComponentProps';
import { getStaticImageSrc } from '#/utils/getImageSrc';

import { SearchInternshipsPage } from './SearchInternshipsPage';

export const handle = {
  urlByLocale: searchInternshipsRoutePathByLocale,
  darkBackground: true,
  defaultSearchType: 'INTERNSHIP',
  hideFooterDivider: true,
  searchFromPageType: 'SEARCH',
  showDesktopSearch: true,
  isSearchPage: true,
  showSearchRefinements: true,
  searchRefinements: <ClientOnlyLazySearchInternshipRefinements />,
} satisfies LayoutHandleProps;

export async function loader(
  _: HorizonAppRouteLoaderArgs<typeof searchInternshipsRouteReference>,
) {
  // empty loader
}

export default function SearchInternshipsHorizonRoute(
  _: HorizonAppRouteComponentProps<typeof loader>,
) {
  const { appConfig } = useAppConfig();
  const { i18n, locale } = useI18n();

  const ogImage = (() => {
    switch (locale) {
      case I18nLocale.EN:
        return getStaticImageSrc(
          'og-image-en-internships.jpg',
          appConfig.idealist.staticImgPath,
        );
      case I18nLocale.ES:
        return;
      case I18nLocale.PT:
        return getStaticImageSrc(
          'og-image-pt-internships.jpg',
          appConfig.idealist.staticImgPath,
        );
    }
  })();

  return (
    <RouteModule
      title={
        /* TRANSLATORS: internship search page title */
        i18n('Best Internships Near You, Remote Internships')
      }
      ogImage={ogImage}
    >
      <SearchInternshipsPage />
    </RouteModule>
  );
}
